{
    "DefaultSet_Standard_Reports": "Standaardrapporten",
    "DefaultSet_Power_User_Reports": "Gebruikersrollen",
    "DefaultSet_Contact_Centre_Reports": "Contactcentrumrapporten",
    "DefaultSet_Call_Centre_Reports": "Callcenterrapporten",
    "DefaultSet_SIP_Reports": "SIP-rapporten",
    "NAME": "ReportingDefaultReportSets",
    "DefaultSet_Enhanced_Call_Centre_Reports": "Verbeterde callcenterrapporten",
    "DefaultSet_Call_Centre_Agent_Reports": "Rapporten voor callcenteragenten",
    "DefaultSet_Essentials_Reports_MST": "CXA-standaardrapporten",
    "DefaultSet_Professional_Reports_MST": "CXA Ongebruikte rapporten",
    "DefaultSet_Call_Centre_Agent_Reports_MST": "CXA Premium-rapporten",
    "DefaultSet_Call_Center_Reports": "Rapporten voor callcenters",
    "DefaultSet_Enhanced_Call_Center_Reports": "Verbeterde callcenterrapporten"
}